import { cx } from "@emotion/css";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useFontSize } from "src/hooks/useFontSize";

/** "Ostatnia zmiana" — zmiana fiszki nie bumpuje updatedAt zestawu, więc bierzemy najnowszą datę. */
export function DeckLastChange({
	dates,
}: {
	dates: Array<string | undefined>;
}) {
	const { t } = useTranslation();
	const { fontSizeClass } = useFontSize();
	const lastChange = dates.filter(Boolean).sort().pop();

	return (
		<span className={cx(fontSizeClass, "text-grey")}>
			{lastChange &&
				t("modals.editDeck.lastChange", "Ostatnia zmiana: {{date}}", {
					date: dayjs(lastChange).format("DD-MM-YYYY HH:mm"),
				})}
		</span>
	);
}
